import Menu from './Menu';
import withRole from '../../hocs/withRole';

export default [{
  path: '/prism',
  exact: true,
  component: withRole('*', Menu),
}];
